<!-- Start Facility Area -->
<section class="process-area ptb-100">
    <!--data-aos="fade-up" data-aos-delay="100"-->
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-4 col-sm-6 col-md-6" *ngFor="let Content of facilityContent1; let i = index">
                <div class="single-facility-box">
                    <!--[attr.data-aos]="'fade-up'"
         [attr.data-aos-delay]="100 + (i * 100)"-->
                    <div class="item">
                        <div class="icon">
                            <i class='{{Content.icon}}'></i>
                        </div>
                        <h3>{{Content.title}}</h3>
                        <p>{{Content.paragraph}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Facility Area -->

